export interface IDispatchInput {
  passenger_first_name: string;
  passenger_last_name: string;
  passenger_phone: string;
  fleet_model_id: string;
  pickup_location: string;
  drop_off_location: string;
  pickup_latitude: number;
  pickup_longitude: number;
  drop_off_latitude: number;
  drop_off_longitude: number;
  driver_id?: string | null | undefined;
}

export interface ILocation {
  lat: number;
  lng: number;
}

export interface IDriverLocationResponse {
  message: string;
  status: number;
  data: IDriverLocation[];
}

export interface IDriverLocation {
  id: string;
  first_name: string;
  middle_name: string;
  last_name: string;
  image: string;
  fleet: Fleet;
  latitude: number;
  longitude: number;
  is_online?: boolean;
  last_updated?: string;
}

export interface Fleet {
  id: string;
  brand: string;
  model: string;
  color: string;
  plate_number: string;
  production_year: number;
  has_tinted_windows: boolean;
  has_ac: boolean;
  door_number: number;
  passenger_seat: number;
  image: string;
  fleet_model: FleetModel;
}

export interface FleetModel {
  id: string;
  name: string;
  image: string;
}

export interface IDispatchTripInput {
  pickup_location: {
    latitude: number;
    longitude: number;
  };
  drop_off_location: {
    latitude: number;
    longitude: number;
  };
  fleet_model_id: string;
  passenger_phone: string;
  passenger_first_name: string;
  passenger_last_name: string;
  driver_id: string | null | undefined;
  pickup_address: string | undefined;
  drop_off_address: string | undefined;
}

export enum RequestStatus {
  unauthorized = "unauthorized",
  loading = "loading",
  not_found = "not_found",
  accepted = "accepted",
  timeout = "timeout",
  incoming_request = "incoming_request",
  cancelled = "cancelled",
  already_on_trip = "already_on_trip",
  NOT_FOUND = "NOT_FOUND",
}

export interface IDispatchTripResponseData {
  message: string;
  status: RequestStatus;
  data?: ITripRequestData;
}

export interface IDispatchTripResponse {
  data: string;
}

export interface ITripRequestData {
  pickup_longitude: number;
  passenger_id: string;
  drop_off_address: string;
  drop_off_latitude: number;
  price: number;
  id: string;
  admin_id: string;
  created_at: string;
  pickup_address: string;
  pickup_latitude: number;
  drop_off_longitude: number;
  distance: number;
  status: string;
  updated_at: string;
}

export interface ITripRequestDriverLocation {
  latitude: number;
  longitude: number;
}

export type ActiveMarkerType = "pickup" | "destination";
export interface ILocation {
  lat: number;
  lng: number;
}

export interface ILocationWithToken extends ILocation {
  token: string;
}

export interface ITripRequestSearchForDriverResponse {
  message: string;
  status: string;
  data: {
    passenger_id: string;
    pickup_address: string;
    pickup_longitude: number;
    pickup_latitude: number;
    drop_off_address: string;
    drop_off_longitude: number;
    drop_off_latitude: number;
    distance: number;
    price: number;
    status: string;
    pickup_arrival_time: string;
    destination_arrival_time: string;
    id: string;
    dispatched_by: string;
    base_price: number;
    km_price: number;
    price_per_kilo_meter: number;
    price_per_minute: number;
    dispatcher: string;
    minute_price: number;
    cancellation_rate_price: number;
    high_demand_rate_price: number;
    working_time_rate_price: number;
    exceeded_amount: number;
    admin_id: string;
    created_at: string;
    updated_at: string;
  };
}
